
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import {
    align,
    border,
    display,
    whiteSpace,
    width
} from '../../../../../../../commonStyles.js';
import styles from './styles.js';

const Checkbox = ({
    columns,
    filter,
    filterIndex,
    filterGroup,
    filterGroupCollectionIndex,
    filterGroupIndex,
    handleCheckboxChange
}) => {
    return (
        <div className={css(display.table, width.full)}>
            <div className={css(display.tableCell, width.full, align.verticalAlignMiddle)}>
                <div style={{ marginBottom: '8px' }}>
                    <label
                        className={css(styles.container, border.none, display.table)}
                        htmlFor={`checkbox-filter_${filterIndex}-${filterGroupIndex}-${filterGroupCollectionIndex}`}
                    >
                        <div className={css(display.tableCell, align.verticalAlignTop, whiteSpace.normal)}>
                            <span className={css(styles.container)}>
                                <input
                                    type="checkbox"
                                    id={`checkbox-filter_${filterIndex}-${filterGroupIndex}-${filterGroupCollectionIndex}`}
                                    checked={filter.data.value}
                                    className={css(styles.checkboxInput)}
                                    data-filter-index={filterIndex}
                                    data-filter-group-index={filterGroupIndex}
                                    data-filter-group-collection-index={filterGroupCollectionIndex}
                                    data-input-type={filterGroup.inputType}
                                    name={`checkbox-filter_${filterIndex}-${filterGroupIndex}-${filterGroupCollectionIndex}`}
                                    onChange={handleCheckboxChange}
                                />
                                <span
                                    data-fake-checkbox="true"
                                    className={
                                        filter.data.value ?
                                            css(styles.fakeCheckboxChecked) :
                                            css(styles.fakeCheckbox)
                                    }
                                >
                                    {
                                        filter.data.value ?
                                            <span className={css(styles.fakeCheckboxCheckmark)}>
                                                <svg
                                                    className={css(styles.fakeCheckboxCheckmarkSvg)}
                                                    viewBox="0 0 52 52"
                                                    fill="currentColor"
                                                    fillOpacity="0"
                                                    stroke="#ffffff"
                                                    strokeWidth="3"
                                                    aria-hidden="true"
                                                    role="presentation"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                >
                                                    <path d="M19.1 25.2l4.7 6.2 12.1-11.2" />
                                                </svg>
                                            </span> : null
                                    }
                                </span>
                            </span>
                        </div>
                        <div className={css(display.tableCell, align.verticalAlignTop, whiteSpace.normal)}>
                            <span className={css(styles.title)}>
                                <span>
                                    {filter.title}
                                </span>
                            </span>
                            {
                                filter.subtitle ?
                                    <span
                                        className={
                                            columns ?
                                                css(styles.subtitle, styles.smallSubtitle) : css(styles.subtitle)
                                        }
                                    >
                                        {filter.subtitle}
                                    </span> : null
                            }
                        </div>
                    </label>
                </div>
            </div>
            {
                filter.icon ?
                    <div className={css(display.tableCell, align.verticalAlignTop)}>
                        <img
                            src=""
                            width="40"
                        />
                    </div> : null
            }
        </div>
    );
};

Checkbox.propTypes = {
    columns: PropTypes.number,
    filter: PropTypes.object.isRequired,
    filterGroup: PropTypes.object.isRequired,
    filterGroupCollectionIndex: PropTypes.number.isRequired,
    filterGroupIndex: PropTypes.number.isRequired,
    filterIndex: PropTypes.number.isRequired,
    handleCheckboxChange: PropTypes.func.isRequired
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/filters/Checkbox/Checkbox.jsx